import React from 'react';

import styled from 'styled-components';

import { ITEM_VIEW_HISTORY_CLASS } from '../constants';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: var(--font-regular);
  font-size: 12px;
  color: var(--dark-blue);
  cursor: pointer;
  user-select: none;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.5s ease,
    visibility 0.5s ease;
`;

interface Props {
  onClick: () => void;
}

const ItemViewHistory = ({ onClick }: Props) => (
  <Container className={ITEM_VIEW_HISTORY_CLASS} onClick={onClick}>
    <span>·</span>
    <span>View History</span>
  </Container>
);

export default ItemViewHistory;
